// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.VIEW_REWARD.REWARD_SUPPORT

export const REWARD_SUPPORT = {
  TAB_VIEWED: 'support-tab_viewed'
};
